import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import { adminRoutes } from '../common/routes';
import { DEFAULT_LANDING_PAGE } from '../common/v2/constants';
import {
  useEffectiveRoleViewAuthorizationServiceContext,
  useFeatureAccessServiceContext,
  useFeatureFlagsServiceContext,
  useLatestPreferencesContext,
} from '../common/v2/context/contexts';
import { DashboardContextProvider } from '../common/v2/context/DashboardContextProvider';
import { LegacyDomainScopedContextProvider } from '../common/v2/context/LegacyDomainScopedContextProvider';
import { PrivateRoute } from './PrivateRoute';

export const AdminRoutes = () => {
  const authorizationService =
    useEffectiveRoleViewAuthorizationServiceContext();
  const featureAccessService = useFeatureAccessServiceContext();
  const featureFlagsService = useFeatureFlagsServiceContext();
  const latestPreferences = useLatestPreferencesContext();
  const companyLandingPage =
    latestPreferences.customLandingPage ?? DEFAULT_LANDING_PAGE;
  const enabledPages = adminRoutes(
    featureAccessService,
    featureFlagsService,
    authorizationService
  ).filter((r) => r.isEnabled?.() ?? true);
  console.log2('AdminRoutes', { enabledPages });

  return (
    <DashboardContextProvider>
      <LegacyDomainScopedContextProvider>
        <Switch>
          {enabledPages.map((route) => (
            <PrivateRoute
              key={route.id}
              component={route.comp()}
              {...route}
              guard={() => {
                const isSuperAdmin =
                  authorizationService.canSeeSuperAdminMenu();
                if (!isSuperAdmin) {
                  return <Redirect from="/" to={companyLandingPage} />;
                }
              }}
            />
          ))}
          <Redirect from="*" to={companyLandingPage} />
        </Switch>
      </LegacyDomainScopedContextProvider>
    </DashboardContextProvider>
  );
};
